import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class PlayerTracks extends AbstractRequestTask {
  constructor(service = "", params, headers) {
    super();
    this._config = getAppConfig();
    this._service = service;
    this.method = params.method;
    this._params = params.payload;
    this._headers = headers;
    this.cm_access_token = headers && headers.cm_access_token ? headers.cm_access_token : null;
    if(headers && headers.cm_access_token) {
      delete headers.cm_access_token;
    }

    if(!this.cm_access_token) {
      if(params.cm_access_token) {
        this.cm_access_token = params.cm_access_token;
      }
    }
  }

  getMethod() {
    if (this.method) return this.method;
    return "GET";
  }

  getEncType() {
    if (this.getMethod() === "POST") return "multipart/form-data";

    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    const config = getAppConfig();
    const service = `${config.end_point_music}/middleware/player/${this._service}`;

    return service;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.mediasOnly = true;
    params.pagination = false;
    params.current = 0;
    params.start = 0;
    params.size = 9;
    params.audio_type = "mp3";
    params.version = '1.0.0';
    if(!this._params.cm_access_token && this.cm_access_token) {
      params.cm_access_token = this.cm_access_token;
    }
    const _params = { ...params, ...this._params };
    
    return _params;
  }

  getHeaders() {
    if(!this._headers) {
      return null;
    }

    const headers = {
      ...this._headers
    };
    
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default PlayerTracks;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/PlayerTracks.js